export default __webpack_public_path__ + "static/media/thankyou-icon.e42f16a7.png";